import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Home from "./Home";
import Contact from "./Contact";
import NoPage from "./NoPage";
import MyNavbar from "../components/MyNavbar";
import Footer from "../components/Footer";
import WhatsAppButton from "../components/WhatsAppButton";
import Triathlon from "./Triathlon";
import Modalidades from "./Modalidades";
import About from "./About";
import Terapias from "./Terapias";
import Events from "./Events";
import Clientes from "./Clientes";
import Mapa from "./Mapa";
import Treinos from "./Treinos";

import "../css/Layout.css";

const Layout = () => {
  return (
    <div>
      <MyNavbar />
      <main className="content">
        <Routes>
          <Route index element={<Home />} />

          {/* Canonical kebab-case routes */}
          <Route path="/sobre-nos" element={<About />} />
          <Route path="/modalidades" element={<Modalidades />} />
          <Route path="/triathlon-coaching" element={<Triathlon />} />
          <Route path="/terapias" element={<Terapias />} />
          <Route
            path="/clientes-empresariais"
            element={<Clientes />}
          />
          <Route path="/mapa-de-aulas" element={<Mapa />} />
          <Route path="/treinos-virtuais" element={<Treinos />} />
          <Route path="/eventos" element={<Events />} />
          <Route path="/contactos" element={<Contact />} />

          {/* Redirects from old URLs */}
          <Route
            path="/About"
            element={<Navigate to="/sobre-nos" replace />}
          />
          <Route
            path="/Modalidades"
            element={<Navigate to="/modalidades" replace />}
          />
          <Route
            path="/Triathlon"
            element={<Navigate to="/triathlon-coaching" replace />}
          />
          <Route
            path="/Terapias"
            element={<Navigate to="/terapias" replace />}
          />
          <Route
            path="/Clientes empresariais"
            element={<Navigate to="/clientes-empresariais" replace />}
          />
          <Route
            path="/Clientes"
            element={<Navigate to="/clientes-empresariais" replace />}
          />
          <Route
            path="/Mapa aulas"
            element={<Navigate to="/mapa-de-aulas" replace />}
          />
          <Route
            path="/Treinos"
            element={<Navigate to="/treinos-virtuais" replace />}
          />
          <Route
            path="/Events"
            element={<Navigate to="/eventos" replace />}
          />
          <Route
            path="/Contacts"
            element={<Navigate to="/contactos" replace />}
          />

          <Route path="*" element={<NoPage />} />
        </Routes>
      </main>

      <Footer />
      <WhatsAppButton />
    </div>
  );
};

export default Layout;
